module.exports = __webpack_public_path__ + "img/18-2.a15fd122.jpg";